import s from '../styles';
import { Cascader, Col, Dropdown, Input, Row, Menu } from 'antd';
import CustomSelector from 'components/common/Selector';
import Colors from 'assets/Colors';
import MoreOptionHorizontal from 'components/icons/MoreOptionHorizontal';
import { useEffect, useState } from 'react';
import ArrowDown from 'components/icons/ArrowDown';
import './style.css';
import { useTranslation } from 'react-i18next';
import useSubcategories, {
  useCategories,
} from '../../../../../graphql/useSubcategories';

function ItemsCourse({
  handleRemoveItem,
  items,
  values,
  i,
  index,
  setFieldValue,
  errors,
}) {
  const { t } = useTranslation();
  const { categories } = useCategories();
  const { subcategories} = useSubcategories();

  const [itemsSelected, setitemsSelected] = useState(
    values?.mixAndMatch?.steps[i]?.items[index]?.items.map((item) => [item]) ||
      []
  );
  const mixItems = values?.mixAndMatch?.steps[i]?.items[index]?.items || [];
  const mixPrice = values?.mixAndMatch?.steps[i]?.items[index]?.price || 0;
  const mixQuantity =
    values?.mixAndMatch?.steps[i]?.items[index]?.quantity || 0;

  const itemForSearchCategory = itemsSelected[0]?.[0];
  const itemcategoryfinded = items.find(
    (item) => item._id === itemForSearchCategory
  );
  const idSubCategoryfinded = itemcategoryfinded?.subcategoryId;
  const subCategoryfinded = subcategories?.find(
    (item) => item._id === idSubCategoryfinded
  );
  const dataIdSubCategoryfinded = subCategoryfinded?._id;
  const idCategoryFinded = subCategoryfinded?.categoryId;
  const categoryFinded = categories?.find(
    (item) => item._id === idCategoryFinded
  );
  const dataIdCategoryFinded = categoryFinded?._id;

  const [category, setcategory] = useState(
    dataIdCategoryFinded || values?.categorySelectedFor?.[`${i}${index}`] || []
  );
  const [subcategory, setsubcategory] = useState(
    dataIdSubCategoryfinded ||
      values?.subCategorySelectedFor?.[`${i}${index}`] ||
      []
  );

  useEffect(() => {
    isValid();
  }, [mixItems, mixPrice, mixQuantity]);

  const isValid = () => mixItems.length > 0 && mixPrice.length > 0 && mixQuantity.length > 0;

  const allIsIncluded = itemsSelected.some(
    (item) => item[0] === t('components.InventoryItems.AddItem.Mix&Match.all')
  );
  const excludedAll = itemsSelected.some(
    (item) =>
      item[0] === t('components.InventoryItems.AddItem.Mix&Match.uncheckedAlls')
  );

  const dataSelectCategory = categories.map((category) => ({
    value: category._id,
    name: category.name,
  }));

  const dataFilterSubCategory = subcategories.filter((subcategory) => {
    if (category?.length > 1) {
      return subcategory.categoryId === category;
    }
    return subcategory.categoryId === category?.[0];
  });

  const dataSelectSubCategory = dataFilterSubCategory.map((subcategory) => ({
    value: subcategory._id,
    name: subcategory.name,
  }));

  const dataFilterItems = items.filter((item) => {
    if (subcategory?.length > 1) {
      return item.subcategoryId === subcategory;
    }
    return item.subcategoryId === subcategory?.[0];
  });

  const dataSelectItems = dataFilterItems.map((item) => ({
    value: item._id,
    label: item.name,
    price: item.price,
  }));

  if (dataFilterItems.length > 0) {
    dataSelectItems.unshift({
      value: t('components.InventoryItems.AddItem.Mix&Match.all'),
      label: t('components.InventoryItems.AddItem.Mix&Match.all'),
    });
  }

  if (allIsIncluded) {
    const data = dataFilterItems.map((item) => [item._id]);
    setFieldValue(
      `mixAndMatch.steps.${i}.items.${index}.items`,
      data.map((val) => val[0])
    );
    setitemsSelected(data);
  } else if (excludedAll) {
    setFieldValue(`mixAndMatch.steps.${i}.items.${index}.items`, []);
    setitemsSelected([]);
  }

  if (dataSelectItems.length - 1 === itemsSelected.length) {
    dataSelectItems[0] = {
      value: t('components.InventoryItems.AddItem.Mix&Match.all'),
      label: t('components.InventoryItems.AddItem.Mix&Match.all'),
    };
  }

  const dataPriceRecommended = [];

  dataSelectItems.forEach((element) => {
    itemsSelected.forEach((item) => {
      if (element.value === item[0]) {
        dataPriceRecommended.push(parseInt(element.price));
      }
    });
  });

  const valueMin =
    (Math.min(...dataPriceRecommended) +
      (parseInt(values.mixAndMatch.steps[i].items[index].price) | 0)) *
    (parseInt(values.mixAndMatch.steps[i].items[index].quantity) | 0);
  const valueMax =
    (Math.max(...dataPriceRecommended) +
      (parseInt(values.mixAndMatch.steps[i].items[index].price) | 0)) *
    (parseInt(values.mixAndMatch.steps[i].items[index].quantity) | 0);

  useEffect(() => {
    setFieldValue(`maxPrice.${i}${index}`, valueMax);
  }, [valueMax]);

  useEffect(() => {
    setFieldValue(`minPrice.${i}${index}`, valueMin);
  }, [valueMin]);

  const onChangeCategory = (value) => {
    setcategory(value);
    setFieldValue(`subCategorySelectedFor.${i}${index}`, []);
    setsubcategory([]);
    setitemsSelected([]);
  };

  const onChangeSubCategory = (value) => {
    setsubcategory(value);
    setitemsSelected([]);
  };

  function applyItemStyle(selected) {
    return {
      height: '45px',
      color: selected && Colors.text_on_secondary,
      marginBottom: '10px',
      borderRadius: '2px',
      hover: {
        backgroundColor: 'red',
        color: Colors.text_on_secondary,
      },
    };
  }

  const menu = (
    <Menu
      style={{
        overflow: 'auto',
        padding: '8px',
        paddingBottom: 0,
        minWidth: '147px',
        textAlign: 'center',
      }}
    >
      <Menu.Item
        disabled={values.mixAndMatch.steps[i].items.length === 1}
        key="delete"
        onClick={() => {
          handleRemoveItem(i, index);
        }}
        style={{ ...applyItemStyle(), color: Colors.notification_failed }}
      >
        {t('actions.delete')}
      </Menu.Item>
    </Menu>
  );

  const dropdownRender = (menus) => (
    <div className="menu" style={{ width: '250px', overflow: 'none' }}>
      {menus}
    </div>
  );

  return (
    <Row gutter={9} style={{ alignItems: 'end', marginBottom: '9px' }}>
      <Col span={5}>
        <CustomSelector
          borderColor="#959faf"
          options={dataSelectCategory}
          style={{ width: '100%' }}
          placeholder={t(
            'components.InventoryItems.AddItem.Mix&Match.category'
          )}
          value={category}
          onChange={(value) => [
            onChangeCategory(value),
            setFieldValue(`categorySelectedFor.${i}${index}`, value),
          ]}
        />
      </Col>
      <Col span={5}>
        <CustomSelector
          disabled={false}
          borderColor="#959faf"
          options={dataSelectSubCategory}
          style={{
            width: '100%',
            pointerEvents: category?.length >= 1 ? 'auto' : 'none',
          }}
          placeholder={t(
            'components.InventoryItems.AddItem.Mix&Match.subcategory'
          )}
          value={subcategory}
          onChange={(value) => [
            onChangeSubCategory(value),
            setFieldValue(`subCategorySelectedFor.${i}${index}`, value),
          ]}
        />
      </Col>
      <Col span={6}>
        <Cascader
          dropdownRender={dropdownRender}
          bordered={false}
          suffixIcon={<ArrowDown />}
          disabled={!subcategory?.length}
          dropdownMenuColumnStyle={{ background: 'white', height: 'auto' }}
          placeholder={t('components.InventoryItems.AddItem.Mix&Match.AddItem')}
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            border: `0.5px solid ${
              errors?.mixAndMatch?.steps?.[i]?.items?.[index]?.items?.length > 0
                ? Colors.notification_failed
                : Colors.text_secondary
            }`,
            borderRadius: '2px',
            height: '40px',
            fontSize: '12px',
            width: '100%',
            color: Colors.text_primary,
          }}
          defaultValue={itemsSelected}
          value={itemsSelected}
          options={dataSelectItems}
          onChange={(value) => [
            setitemsSelected(value),
            setFieldValue(
              `mixAndMatch.steps.${i}.items.${index}.items`,
              value.map((val) => val[0])
            ),
          ]}
          multiple
          maxTagCount="responsive"
        />
      </Col>
      <Col span={3}>
        <Input
          min={0}
          placeholder="+0.00 €"
          style={{
            height: '40px',
            borderColor: errors?.mixAndMatch?.steps?.[i]?.items?.[index]?.price
              ? Colors.notification_failed
              : Colors.text_secondary,
          }}
          type="number"
          name="price"
          value={values.mixAndMatch.steps[i].items[index].price }
          onChange={(e) => {        
            if (parseFloat(e.target.value) < 0) {
              setFieldValue(`mixAndMatch.steps.${i}.items.${index}.price`, '0');
            } else {
              setFieldValue(`mixAndMatch.steps.${i}.items.${index}.price`, e.target.value);
            }
          }}
        />
      </Col>
      <Col span={3}>
        <Input
          placeholder="0"
          style={{
            height: '40px',
            borderColor: errors?.mixAndMatch?.steps?.[i]?.items?.[index]
              ?.quantity
              ? Colors.notification_failed
              : Colors.text_secondary,
          }}
          type="number"
          name="quantity"
          value={values.mixAndMatch.steps[i].items[index].quantity}
          onChange={(e) => [
            setFieldValue(
              `mixAndMatch.steps.${i}.items.${index}.quantity`,
              e.target.value
            ),
          ]}
        />
      </Col>
      <Col span={2}>
        <s.TableCell>
          <Dropdown
            placement="bottomRight"
            overlay={menu}
            trigger={['click']}
            arrow
          >
            <div className="dropdownIcon">
              <MoreOptionHorizontal />
            </div>
          </Dropdown>
        </s.TableCell>
      </Col>
    </Row>
  );
}

export default ItemsCourse;
